import { Injectable, signal } from '@angular/core';
import { Toast, ToastType } from './toast.model';

@Injectable({
  providedIn: 'root',
})

class ToastContainerService {
  private toastsSignal = signal<Toast[]>([]);
  readonly toasts = this.toastsSignal.asReadonly();

  show(message: string, type: ToastType = 'info', duration: number = 3000) {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast: Toast = { id, message, type, duration };

    this.toastsSignal.update((current) => [...current, newToast]);

    if (duration > 0) {
      setTimeout(() => {
        this.dismiss(id);
      }, duration);
    }
  }

  // Gracefully trigger exit animation before removal
  dismiss(id: string) {
    // 1. Mark as exiting so CSS animation plays
    this.toastsSignal.update((current) =>
      current.map((t) => (t.id === id ? { ...t, exiting: true } : t))
    );

    // 2. Actually remove from DOM after the animation completes (300ms)
    setTimeout(() => {
      this.remove(id);
    }, 300);
  }

  remove(id: string) {
    this.toastsSignal.update((current) => current.filter((t) => t.id !== id));
  }
}

export { ToastContainerService };